import { render, staticRenderFns } from "./DepartmentPIC.vue?vue&type=template&id=a94d9900&"
import script from "./DepartmentPIC.vue?vue&type=script&lang=js&"
export * from "./DepartmentPIC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports